import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';

const FAQS = [
  {
    q: 'كيف أتابع حالة طلبي؟',
    a: 'من صفحة "طلباتي" في حسابك هتلاقي كل تفاصيل الطلب وحالته لحظة بلحظة، من التجهيز لحد التوصيل.',
  },
  {
    q: 'ما هي مدة التوصيل؟',
    a: 'التوصيل داخل المدن الرئيسية بياخد من 2 إلى 4 أيام عمل، وللمناطق الأخرى من 4 إلى 7 أيام عمل حسب سياسة الشحن والتوصيل.',
  },
  {
    q: 'إزاي أقدر أرجع منتج اشتريته؟',
    a: 'تقدر تطلب إرجاع أي منتج خلال 14 يوم من الاستلام طالما لسه بحالته الأصلية، التفاصيل كاملة في صفحة سياسة الإرجاع.',
  },
  {
    q: 'هل الدفع عند الاستلام متاح؟',
    a: 'أيوه، الدفع عند الاستلام متاح في معظم المناطق بجانب الدفع الإلكتروني بالبطاقات.',
  },
  {
    q: 'نسيت كلمة المرور، أعمل إيه؟',
    a: 'من صفحة تسجيل الدخول اختار "نسيت كلمة المرور" وهنبعتلك رابط لإعادة تعيينها على بريدك الإلكتروني.',
  },
];

const FaqItem = ({ faq, isOpen, onToggle }) => (
  <div className="border-b border-gray-100 last:border-b-0">
    <button
      type="button"
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-4 py-5 text-right"
    >
      <span className="font-bold text-[#1B1B1F]">{faq.q}</span>
      <span
        className={`shrink-0 w-8 h-8 rounded-full bg-[#F6F5F2] flex items-center justify-center text-[#1B1B1F] transition-transform duration-300 ${
          isOpen ? 'rotate-45 bg-[#F2B705]' : ''
        }`}
        aria-hidden="true"
      >
        +
      </span>
    </button>

    <div
      className={`grid transition-all duration-300 ease-in-out ${
        isOpen ? 'grid-rows-[1fr] opacity-100 pb-5' : 'grid-rows-[0fr] opacity-0'
      }`}
      style={{ display: 'grid' }}
    >
      <div className="overflow-hidden">
        <p className="text-gray-600 leading-7">{faq.a}</p>
      </div>
    </div>
  </div>
);

const HelpCenter = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div dir="rtl">
      <PageBanner
        eyebrow="نحن هنا لمساعدتك"
        title="مركز المساعدة"
        subtitle="لقيت إجابات على أكتر الأسئلة اللي بتوصلنا، ولو محتاجة حاجة تانية فريقنا جاهز."
      />

      <div className="container mx-auto px-4 py-14">
        <div className="grid lg:grid-cols-3 gap-10">

          <div className="lg:col-span-2 bg-white rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.06)] p-6 md:p-8">
            <h2 className="text-xl font-bold text-[#1B1B1F] mb-2">الأسئلة الشائعة</h2>
            <p className="text-gray-500 text-sm mb-4">دوسي على أي سؤال عشان تشوفي الإجابة</p>

            <div>
              {FAQS.map((faq, index) => (
                <FaqItem
                  key={faq.q}
                  faq={faq}
                  isOpen={openIndex === index}
                  onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
                />
              ))}
            </div>
          </div>

          <div className="bg-[#1B1B1F] text-white rounded-2xl p-8 h-fit">
            <h3
              className="text-xl font-bold mb-3"
              style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
            >
              لسه محتاجة مساعدة؟
            </h3>
            <p className="text-gray-400 text-sm leading-7 mb-6">
              فريق خدمة العملاء متاح يومياً للرد على استفساراتك بأسرع وقت ممكن.
            </p>

            <Link
              to="/contact-us"
              className="inline-flex items-center justify-center w-full px-6 py-3 rounded-full bg-[#F2B705] text-[#1B1B1F] font-bold hover:bg-white transition-colors"
            >
              اتصل بنا
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
